import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setLoader, createEmptyCart } from "../../actions";
import ProductItem from "../ProductItem";
import Columns from 'react-columns';
import { useSellerShop } from "../../hooks/useAmplifyData";

const SellerProfilePage = () => {
  const dispatch = useDispatch();
  const { sellerurl: shopUrl } = useParams();
  const auth = useSelector(state => state.auth);

  // Fetch seller and products using Amplify Gen 2
  const {
    seller,
    products,
    isLoading,
    isLoadingProducts,
    error,
  } = useSellerShop(shopUrl);

  useEffect(() => {
    if (auth.is_signed_in) {
      dispatch(createEmptyCart());
    }
  }, [auth.is_signed_in, dispatch]);

  // Show/hide loader based on loading state
  useEffect(() => {
    if (isLoading) {
      dispatch(setLoader(true, "Fetching Seller information..."));
    } else {
      dispatch(setLoader(false, null));
    }
  }, [isLoading, dispatch]);

  const renderProducts = () => {
    return products.map(product => (
      <ProductItem
        key={product.product_id}
        product={{
          // Map DynamoDB fields to expected format
          id: product.product_id,
          name: product.product_name,
          sku: product.sku,
          price: product.price,
          image: product.image_url,
          images: product.images || [],
          type_id: product.is_gift_card ? 'giftcard' : product.product_type,
          is_giftcard: product.is_gift_card,
          seller_id: product.seller_id,
          qty: product.quantity || 0,
        }}
      />
    ));
  };

  if (error) {
    return (
      <div id="page-sellerprofile">
        <div>Seller not found.</div>
      </div>
    );
  }

  if (!seller) {
    return null;
  }

  return (
    <div id="page-sellerprofile">
      <div id="seller-profile-header">
        <div id="seller-profile-image">
          <img
            className="wk-mp-collection-logo"
            src={seller.logo_pic}
            alt={seller.shop_title}
          />
        </div>
        <div id="seller-profile-desc">{seller.company_description}</div>
      </div>
      <div className="product-tile-parent">
        {isLoadingProducts && products.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>Loading products...</div>
        ) : (
          <Columns columns="1">
            {renderProducts()}
          </Columns>
        )}
      </div>
      <div className="clear"></div>
    </div>
  );
};

export default SellerProfilePage;
